/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FixBadInstrumentLinkTokensRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixBadInstrumentLinkTokens.pb'
import {FixBadInstrumentLinkTokensResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixBadInstrumentLinkTokens.pb'


export const fixBadInstrumentLinkTokens = (request: FixBadInstrumentLinkTokensRequest, options?: CashRequestOptions) => post<FixBadInstrumentLinkTokensRequest, FixBadInstrumentLinkTokensResponse>("/2.0/cash/fix-bad-instrument-link-tokens", request, {...options, rejectOnError: true })